





































































import { defineComponent, reactive, toRefs, ref, onMounted } from '@vue/composition-api';
import http from "../../plugins/http"
import moment from 'moment'
import { BModal } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue"
import SumupResultRankTab from "../../components/SumupResultRankTab.vue"
import { SumupGroup, RankResult, AverageResult } from "../../modules/teacher/SumupResultRankListTotal"

export interface Data {
  sumup_group_id: string
  curriculum_id: string
  sumupGroup: SumupGroup
  rankResults: RankResult[]
  averageResults: AverageResult[]
  additionTarget: RankResult
  fields: any[]
  rows: any[]
  passingLength: number
  passingScore: number
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-result-rank-tab": SumupResultRankTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: "",
      curriculum_id: "",
      sumupGroup: null,
      rankResults: [],
      averageResults: [],
      additionTarget: null,
      fields: [],
      rows: [],
      passingLength: 0,
      passingScore: null,
      errors: new Array<string>()
    });

    /******************************
     * 備考モーダル表示
     ******************************/

    const showAdditionModal = (row: any) => {
      const student_no_character = row[0];
      state.additionTarget = state.rankResults.find(x => x.student_no_character == student_no_character);
      modalRef.value.show();
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "-";
    };

    /******************************
     * 一覧得点列のフォーマッター
     ******************************/

    const scoreFormatter = (value: any) => {
      return value == -1 ? "欠席" : `${value}点`;
    }

    /******************************
     * 一覧順位列のフォーマッター
     ******************************/

    const rankFormatter = (value: any) => {
      return value == 10000 ? "-" : `${value}位`;
    }

    /******************************
     * 一覧偏差値列のフォーマッター
     ******************************/

    const stdScoreFormatter = (value: any) => {
      return value == -1 ? "-" : `${value}`;
    }

    /******************************
     * 戻る矢印アイコン押下
     ******************************/

    const goSumupList = () => {
      context.root.$router.push("/teacher_site/sumup_list");
    };

    /******************************
     * 合格点変更ボタン押下
     ******************************/

    const changePassingScore = async () => {

      state.errors = [];
      
      if(state.sumupGroup.passing_score && !Number.isInteger(Number(state.sumupGroup.passing_score))){
        state.errors.push("合格点は整数を入力してください。");
        return;
      }
      
      if (!window.confirm('合格点を変更します。よろしいですか？')) {
        return;
      }

      const params = {
        passing_score: state.sumupGroup.passing_score
      };

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sumup_result_rank_list_total/change_passing_score/${state.sumup_group_id}`, params).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      //context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      state.curriculum_id = context.root.$route.params.curriculum_id == null ? "" : context.root.$route.params.curriculum_id;
      await http.get(`/api/teacher/sumup_result_rank_list_total?sumup_group_id=${state.sumup_group_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumupGroup = new SumupGroup(response.data.sumup_group);
        state.rankResults = response.data.rank_results.map((x: any) => new RankResult(x));
        state.rows = state.rankResults.map(x => x.rowObject)
        state.averageResults = response.data.average_results.map((x: any) => new AverageResult(x));
        state.additionTarget = state.rankResults[0];
        state.passingLength = state.rankResults.filter(x => x.isPassing).length;
        state.passingScore = state.sumupGroup.passing_score ? Number(state.sumupGroup.passing_score) : null;

        const colCount = Math.max(...state.rankResults.map(x => x.colCount));
        let curriculumConIdx = 0;
        const curriculumHeader = ["得点", "順位", "偏差値"];
        for(let i = 0; i < colCount; i++){
          if(state.sumupGroup.passing_score && i + 1 == colCount){
            state.fields.push({key: String(i), label: "合否", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 0){
            state.fields.push({key: String(i), label: "受験番号", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 1){
            state.fields.push({key: String(i), label: "氏名", sortable: true, class: 'text-center b-table-th-td'});
          }else if(i == 2){
            state.fields.push({key: String(i), label: "備考", sortable: true, class: 'text-center b-table-th-td'});
          }else if(curriculumConIdx == 0){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'scoreFormatter'});
          }else if(curriculumConIdx == 1){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'rankFormatter'});
          }else if(curriculumConIdx == 2){
            state.fields.push({key: String(i), label: curriculumHeader[curriculumConIdx++], sortable: true, class: 'text-center b-table-th-td', formatter: 'stdScoreFormatter'});
            curriculumConIdx = 0;
          }
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      modalRef,
      convertExecDate,
      goSumupList,
      scoreFormatter,
      rankFormatter,
      stdScoreFormatter,
      showAdditionModal,
      changePassingScore
    };
  }
});
